import { createAsyncThunk } from '@reduxjs/toolkit';
import { API } from '../../api/services';
import { API_METHOD } from '../../api/services/apiMethods';

export const userLoginAPI: any = createAsyncThunk('user-login', async (resp) => {
  const response = await API.post(API_METHOD.Misc.LOGIN, resp);
  return response.data;
});
